let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kVX56"), load("kNFvF"), load("9lByg")]).then(() => parcelRequire('fuCaZ'));